import { defineMessages } from 'react-intl';

const scope = 'app.widgets.BusinessAnalysis';

// Translation of known segment types
export const labels = defineMessages({
    rateType: {
        id: `${scope}.segment.rateType`,
        defaultMessage: 'Rate type',
    },
    roomType: {
        id: `${scope}.segment.roomType`,
        defaultMessage: 'Room type',
    },
    segmentChannel: {
        id: `${scope}.segment.segmentChannel`,
        defaultMessage: 'Channel',
    },
    segmentMarket: {
        id: `${scope}.segment.segmentMarket`,
        defaultMessage: 'Segment',
    },
    segmentSource: {
        id: `${scope}.segment.segmentSource`,
        defaultMessage: 'Source',
    },
});

export default defineMessages({
    title: {
        id: `${scope}.title`,
        defaultMessage: 'Business Analysis',
    },
    noData: {
        id: `${scope}.noDataMessage`,
        description: 'Message shown when there is no data to show',
        defaultMessage: 'No existing data for the period.',
    },
    othersLabel: {
        id: `${scope}.labels.others`,
        description: 'Label for the condensed "others" row',
        defaultMessage: 'Others',
    },
    totalsLabel: {
        id: `${scope}.labels.totals`,
        description: 'Label for the totals row',
        defaultMessage: 'Total',
    },
    missingLabel: {
        id: `${scope}.labels.missing`,
        description: "Placeholder label when it isn't set",
        defaultMessage: 'N/A',
    },
});
